/* Shared photo viewport behaviour; no catalog, source crop or focus changes. */
(() => {
  if (document.documentElement.dataset.artistMediaViewportReady) return;
  document.documentElement.dataset.artistMediaViewportReady = 'true';
  const groups = () => [...document.querySelectorAll('[data-artist-viewport]')].filter(group => group.getClientRects().length);
  function headerBottom() {
    let bottom = 12;
    const header = document.querySelector('#SiteHeader');
    for (let node = header; node && node !== document.body; node = node.parentElement) {
      const rect = node.getBoundingClientRect();
      const style = getComputedStyle(node);
      if (style.position === 'fixed') {
        // Impulse slides its fixed header into view after scrolling. Reserve its
        // settled height rather than the temporarily translated visible slice.
        const inset = Math.max(0, parseFloat(style.top) || 0);
        const announcement = node === header && document.body.classList.contains('has-sticky-announcement-bar')
          ? parseFloat(getComputedStyle(document.body).getPropertyValue('--sticky-announcement-bar-height')) || 0 : 0;
        bottom = Math.max(bottom, rect.bottom + 12, inset + node.offsetHeight + announcement + 12);
      } else if (style.position === 'sticky' && rect.top <= 1 && rect.bottom > 0) {
        bottom = Math.max(bottom, rect.bottom + 12);
      }
    }
    return bottom;
  }
  function fit(group) {
    if (group.dataset.artistViewport !== 'review') return;
    const thumbs = group.querySelector('.artist-review-thumbnails');
    const width = group.getBoundingClientRect().width;
    const gap = parseFloat(getComputedStyle(thumbs).marginTop) || 18;
    const available = window.innerHeight - headerBottom() - thumbs.getBoundingClientRect().height - gap - 24;
    const size = Math.min(width, 512, Math.max(96, available));
    group.style.setProperty('--artist-media-size', `${size}px`);
  }
  function reveal(group) {
    fit(group);
    const rect = group.getBoundingClientRect();
    const top = headerBottom();
    const bottom = window.innerHeight - 12;
    if (rect.height > bottom - top) return;
    if (rect.top < top || rect.bottom > bottom) window.scrollBy({top: rect.top - top, behavior: 'instant'});
  }
  function refresh(revealCurrent = false) {
    for (const group of groups()) { fit(group); if (revealCurrent) reveal(group); }
  }
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-review-image], [data-product-thumb]');
    const group = control?.closest('[data-artist-viewport]');
    if (group) requestAnimationFrame(() => {
      reveal(group);
      // Let the theme's scroll handler activate a newly fixed header first.
      requestAnimationFrame(() => reveal(group));
    });
  });
  window.addEventListener('resize', () => requestAnimationFrame(() => refresh()));
  window.addEventListener('hashchange', () => requestAnimationFrame(() => {
    // Text/profile anchors must keep their destination in view rather than
    // pulling the visitor back to the product photo above it.
    const revealPhotos = !/^#(?:ArtistProfile-|ArtistInformation(?:Intro|Craft|Specs|Sizes)-|metallico-information-)/.test(location.hash);
    refresh(revealPhotos);
    requestAnimationFrame(() => refresh(revealPhotos));
  }));
  document.addEventListener('shopify:section:load', () => requestAnimationFrame(() => refresh()));
  requestAnimationFrame(() => refresh());
})();
